import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../messages";
import { clsx } from "clsx";
const fields = [
    {
        label: "customerName",
        valueKey: "CustomerName"
    },
    {
        label: "brandModel",
        valueKey: "MakeModel"
    },
    {
        label: "serialReg",
        valueKey: "ObjectSerialNumber"
    },
    {
        label: "sellerName",
        valueKey: "SellerName"
    },
    {
        label: "startDate",
        valueKey: "StartDate"
    },
    {
        label: "endDate",
        valueKey: "EndDate"
    },
    {
        label: "timeLeft",
        valueKey: "RemainingTerms"
    }
];
const ContractInfoCard = ({ application, classes }) => {
    const intl = useIntl();
    return (_jsx(Box, { className: clsx(classes.card, classes.customerCard), children: fields.map(({ label, valueKey }) => (_jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle2", children: intl.formatMessage(messages[label]) }), _jsx(Typography, { variant: "body2", children: application?.[valueKey] || "-" })] }, label))) }));
};
export default ContractInfoCard;
//# sourceMappingURL=ContractInfoCard.js.map